
import BaseAlert from "@/components/base/BaseAlert.vue";
import BaseCalendar from "@/components/base/BaseCalendar.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import useBookingCalendar from "@/composables/useBookingCalendar";
import useCalendarNote from "@/composables/useCalendarNote";
import { DirectionEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { useVuelidate } from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { computed, defineComponent, onMounted } from "vue";

export default defineComponent({
	name: "TripDatePicker",
	components: {
		BaseSection,
		BaseCalendar,
		BaseSpinner,
		BaseAlert,
	},
	emits: ["selected", "dateChanged"],
	setup(props, { emit }) {
		const { getDate, setDate, getBooking, getIsLocked } = useBookingStore();

		const {
			getNextAvailableDate,
			hasOutwardDate,
			hasReturnDate,
			setDefaultDate,
			availableDatesOutward,
			availableDatesReturn,
			loading,
		} = useBookingCalendar();

		const { calendarNote, updateCalendarView } = useCalendarNote();

		const rules = {
			booking: {
				outward: helpers.withMessage(
					() => "Please select outward date",
					hasOutwardDate as any
				),
				return: helpers.withMessage(
					() => "Please select return date",
					hasReturnDate as any
				),
			},
		};

		const v$ = useVuelidate(rules, { booking: getBooking });

		const tripType = computed(() => {
			return getBooking.tripType;
		});

		const outwardDate = computed({
			get(): Date | undefined {
				return (
					getDate(DirectionEnum.Outward) ??
					getNextAvailableDate(DirectionEnum.Outward)?.start
				);
			},
			set(value: Date | undefined) {
				setDate(DirectionEnum.Outward, value);

				if (value && getBooking.tripType === DirectionEnum.Return) {
					if ((returnDate.value ?? new Date()) < value) {
						setDate(DirectionEnum.Return, value);
					}
				}
				
				emit('dateChanged');
			},
		});

		const returnDate = computed({
			get(): Date | undefined {
				return (
					getDate(DirectionEnum.Return) ??
					getNextAvailableDate(DirectionEnum.Return)?.start
				);
			},
			set(value: Date | undefined) {
				setDate(DirectionEnum.Return, value);
				emit("selected");
				
				emit('dateChanged');
			},
		});

		const handleFromPage = (d: DirectionEnum, e: any) => {
			updateCalendarView(d, e.year, e.month);
		};

		return {
			outwardDate,
			returnDate,
			tripType,
			DirectionEnum,
			v$,
			availableDatesOutward,
			availableDatesReturn,
			loading,
			calendarNote,
			handleFromPage,
			getIsLocked,
		};
	},
});
